export const DIAGNOSTIC_TYPES = {
  QUESTIONNAIRE_BASED: 'Questionnaire Based',
  PHOTO_BASED: 'Photo Based'
};
